<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <template>
        <v-layout>
          <v-flex xs12 sm6 md3>
            <v-btn
              color="primary"
              dark
              @click="
                dialog = true;
                added_items = [];
              "
              >إضافة تارجت لمندوب
            </v-btn>
          </v-flex>

          <v-flex xs12 sm6 md4>
            <v-autocomplete
              outline
              v-model="select_employer"
              :items="mandobs"
              item-text="name"
              item-value="name"
              label="اختر المندوب"
              persistent-hint
              return-object
              single-line
              @change="change_employer_target"
              v-validate="'required'"
              :error-messages="errors.collect('form1.manger')"
              data-vv-name="manger"
              data-vv-scope="form1"
            >
              <template v-slot:append-outer>
                <v-slide-x-reverse-transition mode="out-in">
                </v-slide-x-reverse-transition>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-toolbar color="orange">
              <v-toolbar-title>إضافة تارجت لمندوب </v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
              <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
              <!-- <v-flex xs12 sm6 md3>
            <v-text-field height=10 outline @keyup.enter="search_client_by_code" v-model="client_search_name" label="كود العميل" ></v-text-field>
        </v-flex> -->
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-form ref="form">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md2>
                        <v-autocomplete
                          outline
                          v-model="select_employer_add"
                          :items="mandobs"
                          item-text="name"
                          item-value="name"
                          label="اسم المندوب "
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          type="number"
                          v-model="newItem.target"
                          label=" التارجت"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog2"
                          v-model="modal2"
                          :return-value.sync="date_from"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date_from"
                              label=" التاريخ من"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date_from" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal2 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog2.save(date_from)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog3"
                          v-model="modal3"
                          :return-value.sync="date_to"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date_to"
                              label=" التاريخ الي"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date_to" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal3 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog3.save(date_to)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          v-model="select_item"
                          :items="m_items"
                          item-text="name"
                          item-value="id"
                          label="أختر الصنف"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-btn @click="add_item">add</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-data-table
                      :headers="headers2"
                      :items="added_items"
                      class="elevation-1"
                      :search="search"
                      :loading="loading"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <v-btn
                            style="width: 50px;"
                            @click="remove_item(props.item)"
                            ><v-icon>delete</v-icon></v-btn
                          >
                        </td>
                        <td>{{ props.item.item_name }}</td>
                        <td>
                          <input
                            style="width: 100%;"
                            type="number"
                            v-model="props.item.item_target_number"
                          />
                        </td>
                        <td>
                          <input
                            style="width: 100%;"
                            type="number"
                            v-model="props.item.item_target_price"
                          />
                        </td>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
                <v-btn color="blue darken-1" flat @click="save('form1')"
                  >حفظ</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog2"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog2 = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog2 = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-toolbar color="orange">
              <v-toolbar-title>تعديل تارجت لمندوب </v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-form ref="form">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        اسم المندوب : {{ editItem.employer }}
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          type="number"
                          v-model="editItem.target"
                          label=" التارجت"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog4"
                          v-model="modal4"
                          :return-value.sync="editItem.date_from"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="editItem.date_from"
                              label=" التاريخ من"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editItem.date_from"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal4 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog4.save(editItem.date_from)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog5"
                          v-model="modal5"
                          :return-value.sync="editItem.date_to"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="editItem.date_to"
                              label=" التاريخ الي"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editItem.date_to" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal5 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog5.save(editItem.date_to)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          v-model="select_item"
                          :items="m_items"
                          item-text="name"
                          item-value="id"
                          label="أختر الصنف"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-btn @click="add_item_edit"
                          >اضافة هذا الصنف للتارجت</v-btn
                        >
                      </v-flex>
                    </v-layout>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-data-table
                      :headers="headers2"
                      :items="old_items"
                      class="elevation-1"
                      :search="search"
                      :loading="loading"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <v-btn
                            style="width: 50px;"
                            @click="remove_item_edit(props.item)"
                            ><v-icon>delete</v-icon></v-btn
                          >
                        </td>
                        <td>{{ props.item.item_name }}</td>
                        <td>
                          <input
                            style="width: 100%;"
                            type="number"
                            v-model="props.item.item_target_number"
                          />
                        </td>
                        <td>
                          <input
                            style="width: 100%;"
                            type="number"
                            v-model="props.item.item_target_price"
                          />
                        </td>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
                <v-btn color="blue darken-1" flat @click="update('form2')"
                  >تعديل</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.employer }}</td>
            <td class="text-xs-right">{{ props.item.target }}</td>
            <td class="text-xs-right">{{ props.item.fatworas_sum }}</td>
            <td class="text-xs-right">{{ props.item.rebacks_sum }}</td>
            <td class="text-xs-right">{{ props.item.sadads_sum }}</td>
            <td class="text-xs-right">{{ props.item.achive_sales + " %" }}</td>
            <td class="text-xs-right">{{ props.item.achive_sadad + " %" }}</td>
            <td class="text-xs-right">{{ props.item.date_from }}</td>
            <td class="text-xs-right">{{ props.item.date_to }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>
            <td>
              <v-icon
                v-if="permissions.delete_all == 1 || user.type == 1"
                color="primary"
                @click="edit_fatwora(props.item)"
              >
                edit
              </v-icon>
            </td>
            <td>
              <v-icon
                v-if="permissions.delete_all == 1 || user.type == 1"
                color="danger"
                @click="delete_fatwora(props.item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-dialog v-model="detail_dialog" width="1160" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل تارجت مندوب
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              مندوب :
              {{ item_detail.employer ? item_detail.employer.name : "" }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              تاريخ من :
              {{ item_detail.date_from }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              تاريخ الي :
              {{ item_detail.date_to }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              التارجت :
              {{ item_detail.target }}
            </v-flex>
          </v-layout>
          <hr />
          <v-data-table
            :headers="headers4"
            :items="item_detail.target_item"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_target_number }}</td>
              <td>{{ props.item.item_target_price }}</td>
              <td>{{ props.item.items_number }}</td>
              <td>{{ props.item.items_price }}</td>
              <td>{{ props.item.reback_items_number }}</td>
              <td>{{ props.item.reback_items_price }}</td>
              <td>{{ props.item.achive_number + " %" }}</td>
              <td>{{ props.item.achive_price + " %" }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="detail_dialog = false">
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mandobs,
  items,
  mandob_targets,
  add_mandob_targets,
  update_mandob_targets,
  delete_mandob_targets,
  remove_item_from_target
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,
    dialog2: false,
    rowsPerPageItems: [400, 800],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,

    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_employer_add: { id: "" },
    select_store_to: { id: "" },
    select_employer_add_edit: { id: "" },
    select_store_to_edit: { id: "" },
    select_employer: { id: "" },
    change_store_to: { id: "" },
    is_store_to: false,

    search: "",
    loading: false,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      { text: "الموظف ", value: "store_name_from", align: "right" },
      { text: "التارجت", value: "store_name_to", align: "right" },
      { text: "المبيعات", value: "store_name_to", align: "right" },
      { text: "المرتجعات", value: "store_name_to", align: "right" },
      { text: "السدادات", value: "store_name_to", align: "right" },
      { text: "المتحقق للمبيعات", value: "store_name_to", align: "right" },
      { text: "المتحقق للسدادات", value: "store_name_to", align: "right" },
      { text: "تاريخ من", value: "taslim_date", align: "right" },
      { text: " تاريخ الي ", value: "taslim_date", align: "right" },
      { text: " التاريخ", value: "store", sortable: false, align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تعديل", value: "store", sortable: false, align: "right" },
      { text: " حذف", value: "store", sortable: false, align: "right" }
    ],
    headers2: [
      {
        text: "حذف ",
        align: "right",
        value: "حذف"
      },
      {
        text: " اسم الصنف",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: "تارجت الصنف عدد",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: "تارجت الصنف سعر",
        value: "item_num",
        sortable: false,
        align: "right"
      }
    ],

    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "item_num", sortable: false, align: "right" }
    ],

    headers4: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      {
        text: " التارجت العدد",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " التارجت السعر",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " المبيعات العدد",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " المبيعات السعر",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " المرتجعات العدد",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " المرتجعات السعر",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " المتحقق للعدد",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: " المتحقق للسعر",
        value: "item_num",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    all_fatworas: [],
    m_sadad_types: [],
    m_mandobs: [],
    clients: [],
    m_items: [],
    mandobs: [],
    client_search_name: "",
    newItem: {
      date_from: "",
      date_to: "",
      target: "",
      employer_id: ""
    },
    editItem: {},
    added_items: [],
    old_items: [],
    modal2: false,
    modal3: false,
    modal4: false,
    modal5: false,
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10)
  }),

  computed: {
    mycode() {
      if (this.all_fatworas.length > 0) {
        return (this.code =
          parseInt(this.all_fatworas[this.all_fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    asnaf_q() {
      return this.added_items.length;
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    mandobs().then(response => {
      this.mandobs = response.data;
    });
    items().then(response => {
      this.m_items = response.data;
    });
  },

  methods: {
    initialize() {},

    edit_fatwora(item) {
      this.editItem.id = item.id;
      this.editItem.date_from = item.date_from;
      this.editItem.date_to = item.date_to;
      this.editItem.target = item.target;
      this.editItem.employer = item.employer;
      this.old_items = [];
      for (let h = 0; h < item.target_item.length; h++) {
        this.old_items.push({
          id: item.target_item[h].id,
          item_name: item.target_item[h].item_name,
          item_target_number: item.target_item[h].item_target_number,
          item_target_price: item.target_item[h].item_target_price
        });
      }
      this.dialog2 = true;
    },

    add_item() {
      this.added_items.push({
        item_name: this.select_item.name,
        item_target_number: 1,
        item_target_price: 1,
        item_id: this.select_item.id
      });
      this.select_item = { id: "" };
    },
    add_item_edit() {
      this.old_items.push({
        item_name: this.select_item.name,
        item_target_number: 1,
        item_target_price: 1,
        item_id: this.select_item.id
      });
      this.select_item = { id: "" };
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    remove_item_edit(item) {
      this.$swal({
        title: "هل تريد حذف هذا الصنف من تقسيمة التارجت",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          remove_item_from_target(item.id).then(res => {
            this.loading = false;
            const index = this.old_items.indexOf(item);
            this.old_items.splice(index, 1);
          });
        }
      });
    },
    delete_fatwora(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_mandob_targets(frmData2, item.id).then(response => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.date_from = this.date_from;
          this.newItem.date_to = this.date_to;
          this.newItem.employer_id = this.select_employer_add.id;

          var frmData = new FormData();
          frmData.append("target", JSON.stringify(this.newItem));
          frmData.append("target_detail", JSON.stringify(this.added_items));

          add_mandob_targets(frmData).then(response => {
            Object.assign(this.$data.newItem, this.$options.data().newItem);
            this.fatworas.push(response.data);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },
    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let id = this.editItem.id;

          var frmData = new FormData();
          frmData.append("target", JSON.stringify(this.editItem));
          frmData.append("target_detail", JSON.stringify(this.old_items));

          update_mandob_targets(frmData, id).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },
    change_employer_target() {
      mandob_targets(this.select_employer.id).then(response => {
        this.fatworas = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
        this.is_store_to = false;
        this.change_store_to = { id: "" };
      });
    },

    detailItem(order) {
      this.detail_dialog = true;
      this.item_detail = order;
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
